import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';

const Header: React.FC = () => {
  const location = useLocation();

  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100); // Wait for page transition
    }
    window.history.pushState(null, '', '/');
  };

  const handleNavClick = (e: React.MouseEvent, hash: string) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const section = document.querySelector(hash);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        window.history.pushState(null, '', hash);
      }
    }
  };

  return (
    <header className="main-header">
      <div className="header-content">
        <div className="logo-section">
          <Link 
            to="/" 
            className="logo-link"
            onClick={handleHomeClick}
          >
            <img 
              src="/images/logo.png" 
              alt="Pelyak Nails Logo" 
              className="header-logo"
            />
          </Link>
          <Link 
            to="/"
            className="site-name-link"
            onClick={handleHomeClick}
          >
            NailsRoom
          </Link>
        </div>
        <nav className="main-nav">
          <Link 
            to="/#about-section" 
            className="nav-link"
            onClick={(e) => handleNavClick(e, '#about-section')}
          >
            Rólam
          </Link>
          <Link 
            to="/#pricelist-section" 
            className="nav-link"
            onClick={(e) => handleNavClick(e, '#pricelist-section')}
          >
            Árlista
          </Link>
          <Link 
            to="/#contact-section" 
            className="nav-link"
            onClick={(e) => handleNavClick(e, '#contact-section')}
          >
            Kapcsolat
          </Link>
          <Link to="/references" className="nav-link">Referenciák</Link>
          <Link to="/policy" className="nav-link">Házirend</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header; 